export default __webpack_public_path__ + "static/media/Greenhouse_Outside.f2ead6ac.jpg";